import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { createNewChatSession } from "../../services/api/ChatService";
import { PiNotePencil } from "react-icons/pi";

export function NewChatDialog({ onCreate, text }) {
  const [sessionName, setSessionName] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (sessionName && sessionName.trim() !== "") {
      const payload = { session_name: sessionName.trim() };
      const response = await createNewChatSession(payload);
      if (response) {
        onCreate(response);
      }
    }
  };

  return (
    <Dialog>
      <form>
        <DialogTrigger asChild>
          <Button variant="outline">
            <PiNotePencil />{" "}
            <span className={text ? "ml-2" : ""}>{text || ""}</span>
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Conversation History</DialogTitle>
            <DialogDescription>
              Enter the title for your new chat session to be retrieved in your
              history conversation later.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4">
            <div className="grid gap-3">
              <Label htmlFor="name-1">Name</Label>
              <Input
                id="name-1"
                name="name"
                defaultValue={sessionName}
                onChange={(e) => setSessionName(e.target.value)}
                placeholder="es. ticket resolution #12345"
              />
            </div>
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <Button type="submit" onClick={(e) => handleSubmit(e)}>
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </form>
    </Dialog>
  );
}
